import { useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import { usePermissions } from "shared";

import { TITLES } from "../constants";

const useDeviceGroupInlineActions = () => {
    const { PERMISSIONS, getNoPermissionTooltipTitle } = usePermissions();

    const [rowData, setRowData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const openDialog = (data: any) => {
        setRowData(data);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setRowData(null);
        setIsOpen(false);
    };

    const inlineActions = [
        {
            title: TITLES.EditGroup,
            icon: EditIcon,
            getDisabledText: () =>
                getNoPermissionTooltipTitle(PERMISSIONS.DeviceGroupUpdate),
            clickAction: (data: any) => openDialog(data)
        }
    ];

    return {
        inlineActions,
        rowData,
        isOpen,
        closeDialog
    };
};

export { useDeviceGroupInlineActions };
